import React from 'react'
import Grid from '@material-ui/core/Grid'
import Challenge from 'components_newui/challenge_card/View'

const ChallengeList = ({ challenges, onClick, classes, enableIsHackathon }) => (
  <Grid container spacing={3} className={classes.vf_container_flexbox}>
    {challenges.map(challenge => (
      <Grid item className={classes.challItem} key={challenge.id}>
        <Challenge myChallenge challenge={challenge} urlID={challenge.id}  enableIsHackathon={enableIsHackathon} onClick={() => onClick(challenge.id)} />
      </Grid>
    ))}
  </Grid>
)

export default ChallengeList
